<section class="detail-content">
    <div class="btn-actions" *ngIf="!showAssignRoleSection">
        <button (click)="clickAssignRolesToUser()" mat-raised-button color="primary">
            <mat-icon>add</mat-icon> Asignar roles
        </button>
        <button [disabled]="rolesSelection.selected.length <= 0"
        (click)="clickRemoveSelectedUserRoles()"
         mat-raised-button color="warn">
            <mat-icon>remove</mat-icon> Quitar roles
        </button>
    </div>
    <app-assign-user-roles
    *ngIf="showAssignRoleSection && roles$ | async as roles"
    [roles]="roles"
    [userRoles]="userRoles"
    (rolesToAssign)="receiveRolesToAssign($event)">
    </app-assign-user-roles>
    <div class="table" *ngIf="!loading; else loadingSection">
        <section *ngIf="userRoles.length > 0; else noInfo">
            <table mat-table [dataSource]="userRoles">
                <ng-container matColumnDef="selection">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? toggleAll(): null"
                        [checked]="rolesSelection.hasValue() && isAllSelected()"
                        [indeterminate]="rolesSelection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? rolesSelection.toggle(element) : null"
                        [checked]="rolesSelection.isSelected(element)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>
                        Roles
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.name }}</h6>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </section>
    </div>
</section>

<!-- Template para mostrar en lugar de la tabla si no hay roles asociados a mostrar-->
<ng-template #noInfo>
    <div class="info-span">
        <span>
            <mat-icon>info</mat-icon>
            No hay roles que mostrar
        </span>    
    </div>
</ng-template>

<ng-template #loadingSection>
    <div class="info-span">
        <mat-spinner [diameter]="50"></mat-spinner>
    </div>
</ng-template>